/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Remove_ButtonInputs */

const en_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const fr_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer`)
};

const de_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const it_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovere`)
};

const ru_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалять`)
};

const es_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const zh_cn2_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消除`)
};

const ja_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り除く`)
};

const hi_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निकालना`)
};

const pt_pt2_media_tab_remove_button = /** @type {(inputs: Media_Tab_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Media_Tab_Remove_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_remove_button = /** @type {((inputs?: Media_Tab_Remove_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Remove_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_remove_button(inputs)
	if (locale === "de") return de_media_tab_remove_button(inputs)
	if (locale === "it") return it_media_tab_remove_button(inputs)
	if (locale === "ru") return ru_media_tab_remove_button(inputs)
	if (locale === "es") return es_media_tab_remove_button(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_remove_button(inputs)
	if (locale === "ja") return ja_media_tab_remove_button(inputs)
	if (locale === "hi") return hi_media_tab_remove_button(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_remove_button(inputs)
	return en_media_tab_remove_button(inputs)
});